import { useRouter } from "@tanstack/react-router"
import { ArrowRight2 } from "iconsax-reactjs"
import { useState } from "react"
import { toast } from "sonner"

import { requestDeleteUser } from "@/api"
import { GoBack } from "@/components/shared/layout"
import { Button } from "@/components/ui"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { useAuthStore } from "@/modules/helpers/hooks/shared"
import { sendHaptic } from "@/modules/helpers/utils"

const LegalPage = () => {
  const router = useRouter()
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const { logout } = useAuthStore()

  const menuItems = [
    {
      label: "Chính sách quyền riêng tư",
      to: "/privacy"
    },
    {
      label: "Điều khoản dịch vụ",
      to: "/terms"
    },
    {
      label: "Chính sách thanh toán",
      to: "/payment-policy"
    }
    // {
    //   label: "Hợp đồng",
    //   to: "/contract"
    // }
  ]

  const handleMenuClick = (to: string) => {
    sendHaptic()
    router.navigate({ to })
  }

  const handleDeleteAccount = async () => {
    setIsDeleting(true)
    try {
      await requestDeleteUser()
      toast.success("Yêu cầu xóa tài khoản đã được gửi")
      logout()
      setConfirmDeleteOpen(false)
    } catch {
      toast.error("Không thể xóa tài khoản. Vui lòng thử lại!")
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <div className="flex flex-col h-full bg-white">
      {/* Header */}
      <div className="sticky top-0 z-50">
        <GoBack title="Chính sách và điều khoản" className="bg-white" />
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4">
        <div className="space-y-4">
          {/* About ZZP Section */}
          <div className="space-y-3">
            <div className="bg-background rounded-xl overflow-hidden">
              {menuItems.map((item, index) => (
                <div key={item.label}>
                  <button
                    onClick={() => handleMenuClick(item.to)}
                    className="w-full flex itemsCenter justify-between px-4 py-4 transitionColors"
                  >
                    <span className="text-sm text-primary-800">{item.label}</span>
                    <ArrowRight2 size={16} className="text-gray-400" />
                  </button>
                  {index < menuItems.length - 1 && <div className="h-[1px] bg-gray-100 mx-4" />}
                </div>
              ))}
            </div>
          </div>

          {/* Delete Account Button */}
          {/* <div className="pt-4">
            <Button
              onClick={() => {
                sendHaptic()
                setConfirmDeleteOpen(true)
              }}
              className="w-full flex itemsCenter !bg-red-100 justifyCenter gap-2 py-3"
            >
              <Trash size={18} className="text-red-500" />
              <span className="text-sm font-medium text-red-500">Xóa tài khoản</span>
            </Button>
          </div> */}
        </div>
      </div>

      {/* Confirm Delete Dialog */}
      <Dialog open={confirmDeleteOpen} onOpenChange={setConfirmDeleteOpen}>
        <DialogContent className="w-4/5">
          <DialogHeader>
            <DialogTitle className="text-sm">Bạn có chắc chắn muốn xóa tài khoản?</DialogTitle>
          </DialogHeader>
          <p className="text-xs text-gray-600 mt-2">
            Hành động này không thể hoàn tác. Tất cả dữ liệu của bạn sẽ bị xóa vĩnh viễn.
          </p>
          <div className="flex gap-2 justify-end mt-4">
            <Button
              variant="outline"
              onClick={() => setConfirmDeleteOpen(false)}
              disabled={isDeleting}
            >
              Hủy
            </Button>
            <Button
              onClick={handleDeleteAccount}
              disabled={isDeleting}
              className="bg-red-500 hover:bg-red-600"
            >
              {isDeleting ? "Đang xử lý..." : "Xóa tài khoản"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default LegalPage
